var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-tab-left",
    clipPath: "url(#clip0_2698_245)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 3.58265 3.58265 0 8 0C12.4174 0 16 3.58265 16 8C16 12.4174 12.4174 16 8 16C3.58265 16 0 12.4174 0 8ZM1.35211 8C1.35211 11.6735 4.32654 14.6479 8 14.6479C11.6735 14.6479 14.6479 11.6735 14.6479 8C14.6479 4.32654 11.6735 1.35211 8 1.35211C4.32654 1.35211 1.35211 4.32654 1.35211 8ZM6.71458 9.46479L10.9066 5.27279L10.9073 5.27383C11.1776 5.00358 11.5834 5.00358 11.8536 5.27383C12.1239 5.52117 12.1239 5.94988 11.8536 6.22012L7.18908 10.8847C7.05351 11.0194 6.87305 11.0872 6.71548 11.0872C6.55701 11.0872 6.37745 11.0203 6.24188 10.8847L4.14593 8.78873C3.87568 8.54139 3.87568 8.11268 4.14593 7.84243C4.39327 7.57219 4.82198 7.57219 5.09223 7.84243L6.71458 9.46479Z",
    fill: "#00A708"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2698_245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIcon);
export default __webpack_public_path__ + "static/media/right_icon.2c7bc2c0612b3385f4c79557fd0e30a1.svg";
export { ForwardRef as ReactComponent };